import { render, staticRenderFns } from "./TestQuestionBufferForm.vue?vue&type=template&id=5df27c26&scoped=true&"
import script from "./TestQuestionBufferForm.vue?vue&type=script&lang=ts&"
export * from "./TestQuestionBufferForm.vue?vue&type=script&lang=ts&"
import style0 from "./TestQuestionBufferForm.vue?vue&type=style&index=0&id=5df27c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df27c26",
  null
  
)

export default component.exports